import '../../../stylesheets/nav/nav.css';
import useAuthServer from '../../../hooks/external/vendor/auth/useAuthServer.js';

const Logout = () => {
    const { handleLogout } = useAuthServer();

    return (
        <button 
            className="profile-menu-item profile-menu-item-logout"
            onClick={handleLogout}
        >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="profile-menu-icon">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Logout
        </button>
    );
};

export default Logout;